import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import champs from './taki.fields.json';
import ecrans from './taki.screens.json';
import { MaSemaine } from './canvas/MaSemaine.js';
import { VueLignes } from './canvas/VueLignes.js';
import { importDemoDataset } from './demo-dataset.js';

/**
 * L'APP TIMESHEET (`timesheet`), EN REGIME DECLARE : aucune ligne d'ecran.
 *
 * TROIS FICHIERS, ET C'EST TOUTE L'APP :
 *  - `taki.app.json` : la fiche d'identite (id, nom, icone, entites touchees,
 *    et l'ACCORD du fondateur pour le Space Canvas de Ma semaine, cle `canvas`) ;
 *  - `taki.fields.json` : ce que les champs SONT, jeu par jeu ;
 *  - `taki.screens.json` : OU ils s'affichent (les portes, les vues montees,
 *    le detail par vue, les cartes de la fiche, le tri, les gestes, et par
 *    porte son jeu, ses filtres, ses favoris, ses actions, ses stats et ses
 *    liens).
 *
 * L'ECRAN VIENT DU SOCLE (`EcranDeclare`, `@taki/app-runtime`) : le
 * chargement, les gestes de fiche, l'acces au jeu, les compteurs du menu, les
 * preferences du poste et le panneau de reglages sont ecrits une fois, pour
 * toutes les apps declarees.
 *
 * TROIS PORTES, UN SEUL JEU DE TEMPS. « Ma semaine » et « Journal » montrent
 * LE MEME jeu (`timesheets` / `journal`) : la premiere au geste, sur une grille
 * de semaine (le Space Canvas de `canvas/MaSemaine.tsx`, regle G23), la seconde
 * en tableau, toutes entrees confondues. « Projets » porte le jeu `projects` /
 * `projet`, et chaque entree du journal designe un projet (`projectId`).
 *
 * LE CLIENT D'UN PROJET EST UNE SOCIETE DE L'APP CONTACT, et aucune porte ne
 * la montre ici : la colonne `socle:contactId` est de type `lien` et DESIGNE sa
 * famille (`reference: { family: 'contacts', type: 'organization' }`,
 * `docs/VUES-CONTRAT.md` section 16.11). Le socle en tire le nom, le selecteur
 * et la fleche, qui ouvre la fiche dans l'app Contact. Le titre vient de la
 * convention de la famille (`titreDeFiche`), donc il ne se declare pas.
 *
 * UNE PORTE SOCIETES A VECU ICI, et elle est partie le 21/09/2026 avec la
 * PR #186 du socle : elle n'existait que pour donner de quoi resoudre ce nom,
 * ce qu'une porte du MEME ecran etait seule a savoir faire.
 *
 * CE QUI S'AJOUTE ICI PARCE QUE LA DECLARATION LE NOMME, et rien de plus :
 *  - `fonctions` : le nom, les initiales et les coordonnees d'un client
 *    (`fonctions.ts`), des CALCULS que la porte Clients cite en `fn:` ;
 *  - `canvas` : la surface de la porte `ma-semaine`, declaree dans la fiche
 *    (`canvas.spaces`) et montee ici ; et le rendu de la vue de fiche
 *    « Saisie en lignes » (`vue:timesheet.lignes`), decrite dans `vuesCustom`
 *    de `taki.screens.json` et accordee dans `canvas.views` (27/10/2026) ;
 *  - `demo` : l'import du jeu de demonstration, qui ecrit des DONNEES par le
 *    SDK ; le socle en pose la ligne dans Parametres.
 */
export const timesheetApp = definirAppDeclaree({
  fiche: appInfo,
  champs,
  ecrans,
  canvas: { 'ma-semaine': MaSemaine, 'vue:timesheet.lignes': VueLignes },
  demo: { importer: ({ sdk, orgId }) => importDemoDataset(sdk, orgId) },
});

export default timesheetApp;
